import type { ActionReducerMapBuilder } from '@reduxjs/toolkit/src/mapBuilders';
import { IInsuranceCooperationState } from 'Redux/Slices/InsuranceCooperation/InsuranceCooperationSlice';
import { showOtpScreen } from './ShowOtpScreen/ShowOtpScreen';


export const insuranceCooperationExtraReducers = (builder: ActionReducerMapBuilder<IInsuranceCooperationState>) => {
  showOtpScreen(builder);
};
